import { render, staticRenderFns } from "./TicketTypesSelection.vue?vue&type=template&id=2e020987&scoped=true&"
import script from "./TicketTypesSelection.vue?vue&type=script&lang=js&"
export * from "./TicketTypesSelection.vue?vue&type=script&lang=js&"
import style0 from "./TicketTypesSelection.vue?vue&type=style&index=0&id=2e020987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e020987",
  null
  
)

export default component.exports